import React, { useEffect, useRef, useState } from 'react';

import api from '../../services/api';
import validadorCpfCnpj from '../../services/validadorCpfCnpj';
import { store } from "react-notifications-component";

import estados from "../../services/estados";

import { StyleModal } from '../modal/styles';
import { Loading } from '../../components/loading';
import Input from '../../components/input/input_v2';
import Button from '../../components/button/button_v2';
import ModalAlert from '../../components/modal/modalGeneric';
import ModalGeneric from '../../components/modal/modalGeneric';
import ModalGenericV2 from '../../components/modal/modalGenericV2';
import ButtonV2 from '../../components/button/button_v2';

import mais from "../../assets/Mais.png";

import status0 from "../../assets/icons/icon-status-nao-enviado.png"
import status1 from "../../assets/icons/status-1.png"
import status2 from "../../assets/icons/icon-status-pending.png"
import status3 from "../../assets/icons/icon-status-enviado.svg"
import status4 from "../../assets/icons/icon-status-reload.png"

import * as S from './styles'
import { BodyG, BodyM, H5, TaglinePSpan } from '../../styles/stylesTypography';
import SelectV2 from '../select/select_v2';
import Relation from '../prescriptionsteps/step5/relation';

import Tooltip from "../tooltip";
import { isTotvs, isNfAposReceita, isPrazoNfAposReceitaExpirado, orgaoHomologacaoNfAposReceita, pathExportarReceita, pathExportarNf } from '../../services/globalFunctions';

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
export const USER = "@userinfo";

const mapUnidadeMedidaNf = (unidadeDb) => {
    if (unidadeDb == null || unidadeDb === '') return '';
    const n = String(unidadeDb).trim().toUpperCase();
    if (n === 'L' || n === 'LT') return 'L';
    if (n === 'KG') return 'KG';
    if (n === 'UNIDADE' || n === 'UNIDADES' || n === 'UN') return 'UN';
    return '';
};

const getTituloErroSisdevMT = (homologacaoErro) => {
    if (!homologacaoErro) return null;
    if (/agr[oô]nomo/i.test(homologacaoErro)) return 'Agrônomo não cadastrado no SISDEV';
    if (/falha de comunica[cç][aã]o/i.test(homologacaoErro)) return 'Erro de comunicação com SISDEV';
    if (/produtor/i.test(homologacaoErro) && /n[aã]o (est[aá] )?cadastrad/i.test(homologacaoErro)) return 'Produtor não cadastrado no SISDEV';
    return 'Erro ao homologar no SISDEV';
};

const HomologButtonHistory = ({ ...props }) => {
    const showTotvsNf = isTotvs() && !!props.estado && !!props.nf;

    const [loading, setLoading] = useState(false);
    const [contractSoftId, setContractSoftId] = useState('');
    const [showModalBlock, setShowModalBlock] = useState(false);

    const [idReceitaExport, setIdReceitaExport] = useState();
    const [estadoReceitaExport, setEstadoReceitaExport] = useState();
    const [showModalExport, setModalExport] = useState(false);
    const [motivoAtraso, setMotivoAtraso] = useState('');
    const [newProdutos, setNewProdutos] = useState([]);
    const [newProduto, setNewProduto] = useState(null); // Mantido para compatibilidade

    const [showModalUpload, setModalUpload] = useState(false);
    const [file64, setFile64] = useState(false);
    const [namesfiles, setNamesFiles] = useState([]);
    const [isValidate, setIsValidate] = useState(false);


    const [showModalNFGO, setShowModalNFGO] = useState(false);
    const [showModalNFMG, setShowModalNFMG] = useState(false);
    const [showModalPrazoGO, setShowModalPrazoGO] = useState(false);
    // Aviso exibido no clique do botão (antes de abrir o formulário), separado
    // do showModalPrazoGO acima (que continua servindo de confirmação no
    // envio, como salvaguarda caso o estado mude entre abrir e enviar).
    const [showModalPrazoGOAviso, setShowModalPrazoGOAviso] = useState(false);
    const [showModalNFBA, setShowModalNFBA] = useState(false);
    const [numNFBA, setNumNFBA] = useState('');
    const [erroNumNFBA, setErroNumNFBA] = useState(false);
    const [chaveAcesso, setChaveAcesso] = useState('');
    const [razaoSocial, setRazaoSocial] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [endereco, setEndereco] = useState('');
    const [bairro, setBairro] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [estado, setEstado] = useState('');
    const [dataEmissao, setDataEmissao] = useState('');

    // Array de produtos com todos os campos necessários para cada produto
    const [produtos, setProdutos] = useState([]);
    const [unidadeMedida] = useState([
        { value: 'L', label: 'Litro(s)' },
        { value: 'KG', label: 'Kilo(s)' },
        { value: 'UN', label: 'Unidade(s)' }
    ]);

    // Estados para compatibilidade com código existente
    const [produto, setProduto] = useState('');
    const [unidade, setUnidade] = useState('');
    const [quantidade, setQuantidade] = useState('');
    const [ncmProduto, setNcmProduto] = useState('');


    const [erroChaveAcesso, setErroChaveAcesso] = useState(false);
    const [erroRazaoSocial, setErroRazaoSocial] = useState(false);
    const [erroCpfCnpj, setErroCpfCnpj] = useState(false);
    const [erroCpfCnpjMsg, setErroCpfCnpjMsg] = useState('');
    const cpfCnpjCheckRef = useRef(0);
    const [erroEndereco, setErroEndereco] = useState(false);
    const [erroBairro, setErroBairro] = useState(false);
    const [erroMunicipio, setErroMunicipio] = useState(false);
    const [erroEstado, setErroEstado] = useState(false);
    const [erroDataEmissao, setErroDataEmissao] = useState(false);

    const [erroProduto, setErroProduto] = useState(false);
    const [erroUnidades, setErroUnidades] = useState(false);
    const [erroQuantidade, setErroQuantidade] = useState(false);
    const [erroNcmProduto, setErroNcmProduto] = useState(false);

    const [serieNf, setSerieNf] = useState('');
    const [erroSerieNf, setErroSerieNf] = useState(false);
    const [numNf, setNumNf] = useState('');
    const [erroNumNf, setErroNumNf] = useState(false);
    const [tentouEnviarNFMG, setTentouEnviarNFMG] = useState(false);
    const [showModalSerie, setShowModalSerie] = useState(false);
    const [relationsSicca, setRelationsSicca] = useState([]);
    const [produtosSelecionadosSicca, setProdutosSelecionadosSicca] = useState([]);
    const [quantidadesSicca, setQuantidadesSicca] = useState([]);
    const [embalagensSicca, setEmbalagensSicca] = useState([]);

    // Estado para controlar se o botão deve estar habilitado (começa como false até que todos os campos sejam validados)
    const [formValido, setFormValido] = useState(false);

    const [loadingNFGO, setLoadingNFGO] = useState(false);
    const [loadingNFMG, setLoadingNFMG] = useState(false);
    const [loadingSendNF, setLoadingSendNF] = useState(false);

    // Checagem de prazo de 7 dias para SIDAGO (GO) e SIAGRO DF
    const dataEmissaoReceita = () => {
        if (props.dataReceita && !Array.isArray(props.dataReceita) && props.dataReceita.data_emissao) {
            return props.dataReceita.data_emissao;
        }
        return receitaAtual?.data_emissao || null;
    };

    const isPrazoExpiradoGO = () => isPrazoNfAposReceitaExpirado(dataEmissaoReceita());

    const openPlanos = () => {
        setShowModalBlock(false);
        props.propsLocation.history.push('/planos');
    }

    // homologado 2 é "enviando". Se o órgão já respondeu, o backend grava 1 ou 0.
    // O que sobrou em 2 não atualiza sozinho: o clique chamava /receitas/reprovar.
    // Faz isso uma vez ao exibir o badge, com uma folga para um envio ainda em curso
    // terminar e gravar 1. reprovar só altera a receita se ela continuar em 2.
    const encerrouEnvioRef = useRef(false);
    useEffect(() => {
        if (Number(props.homologado) !== 2 || encerrouEnvioRef.current) return;
        if (typeof props.onNfHomologar === 'function') return;
        if (!props.receitaId) return;

        const timer = setTimeout(async () => {
            if (encerrouEnvioRef.current) return;
            encerrouEnvioRef.current = true;
            try {
                await api.post(`/receitas/reprovar/${props.receitaId}`);
                if (typeof props.updateReceitas === 'function') {
                    props.updateReceitas();
                }
            } catch (_) {
                encerrouEnvioRef.current = false;
            }
        }, 4000);

        return () => clearTimeout(timer);
    }, [props.homologado, props.receitaId]);

    const exportarReceita = async (id, estado, motivo, file64) => {
        if (props.homologado === 2) {
            const response = await api.post(`/receitas/reprovar/${id}`);
            if (response) {
                window.location.href = window.location.href;
            }
        } else if (props.statusEnvio === 1 || props.statusEnvio === 2 || props.statusEnvio === 4 || props.homologado === 0) {
            setLoading(false);
            let user = JSON.parse(localStorage.getItem(USER));

            if (user.contrato.agro_plan_config.is_teste === 1) {
                setShowModalBlock(true);
            } else {
                try {
                    if (isNfAposReceita(estado)) {
                        setLoading(true);
                        const response = await api.post(pathExportarReceita(estado, id));
                        if (response) {
                            let msg = response.data.message;

                            store.addNotification({
                                title: "Sucesso!",
                                message: `${msg}`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });

                            props.updateReceitas();
                        }
                    } else if (estado === 'MT') {
                        setLoading(true);
                        const response = await api.post(`/sisdev/exportar_receita/${id}`);
                        if (response) {
                            let msg = response.data.message;
                            store.addNotification({
                                title: "Sucesso!",
                                message: `${msg}`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                            props.updateReceitas();

                        }
                    } else if (estado === 'SC') {
                        setLoading(true);
                        const response = await api.post(`/cidasc/exportar_receita/${id}`);

                        if (response) {
                            let msg = response.data.message;
                            store.addNotification({
                                title: "Sucesso!",
                                message: `${msg}`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                            props.updateReceitas();

                        }


                        setLoading(false);
                    } else if (estado === 'ES') {
                        setLoading(true);
                        if (motivo === '' && file64 !== '') {
                            const response = await api.post(`/idaf/exportar_receita/${id}`, { receita: file64 });
                            if (response) {
                                let msg = response.data.message;
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                props.updateReceitas();

                            }
                        } else if (motivo !== '' && file64 === '') {
                            const response = await api.post(`/idaf/exportar_receita/${id}`, { xMotivo: motivo });
                            if (response) {
                                let msg = response.data.message;
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                props.updateReceitas();

                            }
                        } else if (motivo !== '' && file64 !== '') {
                            const response = await api.post(`/idaf/exportar_receita/${id}`, { xMotivo: motivo, receita: file64 });
                            if (response) {
                                let msg = response.data.message;
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                props.updateReceitas();

                            }
                        } else {
                            const response = await api.post(`/idaf/exportar_receita/${id}`, { xMotivo: motivo });
                            if (response) {
                                let msg = response.data.message;
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                props.updateReceitas();

                            }
                        }
                    }
                } catch (error) {
                    setLoading(false);
                    if (error.response.status === 400) {
                        store.addNotification({
                            title: "Erro!",
                            message: error.response.data?.errors ? `${error.response.data.errors}` : identifyErrorMenssage(error),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 8000,
                                onScreen: true
                            }
                        });
                        props.updateReceitas();
                    } else if (error.response.status === 406) {
                        setIdReceitaExport(id);
                        setEstadoReceitaExport(estado);
                        setModalExport(false);

                        store.addNotification({
                            title: "Erro!",
                            message: `${error.response.data.errors}`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 8000,
                                onScreen: true
                            }
                        });
                    } else if (error.response.status === 404) {
                        setIdReceitaExport(id);
                        setEstadoReceitaExport(estado);
                        setModalUpload(true);
                    } else {
                        store.addNotification({
                            title: "Erro!",
                            message: `${error.response.data.errors} Aguarde alguns minutos ou entre em contato com nosso suporte!`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 8000,
                                onScreen: true
                            }
                        });
                        props.updateReceitas();
                    }
                }
            }
        }
    }

    const validarMotivo = () => {
        setLoading(true);
        if (idReceitaExport && estadoReceitaExport && motivoAtraso && file64) {
            exportarReceita(idReceitaExport, estadoReceitaExport, motivoAtraso, file64);
            setModalExport(false);
        } else if (idReceitaExport && estadoReceitaExport && motivoAtraso) {
            exportarReceita(idReceitaExport, estadoReceitaExport, motivoAtraso, '');
            setModalUpload(false);
        }
    }

    const validarArquivo = () => {
        if (idReceitaExport && estadoReceitaExport && motivoAtraso && file64) {
            exportarReceita(idReceitaExport, estadoReceitaExport, motivoAtraso, file64);
            setModalUpload(false);
        } else if (idReceitaExport && estadoReceitaExport && file64) {
            exportarReceita(idReceitaExport, estadoReceitaExport, '', file64);
            setModalUpload(false);
        }
    }

    const uploadArquivo = (e) => {
        let user = JSON.parse(localStorage.getItem(USER));
        if (user.contract_software_id === 6) {
            setShowModalBlock(true);
        } else {
            let cont = e.target.files.length;
            cont = cont - 1;
            if (e.target.files) {
                if (e.target.files[cont].type == "application/pdf") {
                    let fil = e.target.files;
                    let file = null;
                    let fileName = "";
                    if (fil.length > 0) {
                        let fileToLoad = fil[0];
                        fileName = fileToLoad.name;

                        let fileReader = new FileReader();

                        fileReader.onload = function (fileLoadedEvent) {
                            file = fileLoadedEvent.target.result;
                            setFile64(file);
                        };

                        // Convert data to base64
                        fileReader.readAsDataURL(fileToLoad);
                    }
                    setNamesFiles(e.target.files[cont].name);

                } else {
                    store.addNotification({
                        title: "Erro!",
                        message: `O arquivo selecionado não possui a extensão correta`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: `Não é possível enviar mais que um arquivo!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    }

    const deleteFile = () => {
        setNamesFiles([]);
        setFile64(false);
        setIsValidate(false);
    };

    const changeChaveAcesso = (value) => {
        setErroChaveAcesso(false);

        // Remove espaços do valor recebido
        const valorSemEspacos = typeof value === 'string' ? value.replace(/\s+/g, '') : value;

        if (valorSemEspacos !== chaveAcesso) {
            setChaveAcesso(valorSemEspacos);
            setErroChaveAcesso(false);

            if (valorSemEspacos.length < 44) {
                setErroChaveAcesso(true);
            } else {
                setErroChaveAcesso(false);
            }
        }
    }

    const changeRazaoSocial = (value) => {
        if (value !== razaoSocial) {
            setRazaoSocial(value);
            setErroRazaoSocial(false);
        }
    }

    const changeCpfCnpj = async (value) => {
        if (value !== cpfCnpj) {
            setCpfCnpj(value);
            setErroCpfCnpj(false);
            setErroCpfCnpjMsg('');

            const numeros = value.replace(/\D/g, '');
            if (numeros.length === 11 || numeros.length === 14) {
                const checkId = ++cpfCnpjCheckRef.current;
                const resultado = await validadorCpfCnpj(value);
                if (checkId !== cpfCnpjCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                if (!resultado.valido) {
                    setErroCpfCnpj(true);
                    setErroCpfCnpjMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
                }
            }
        }
    }

    const changeEndereco = (value) => {
        if (value !== endereco) {
            setEndereco(value);
            setErroEndereco(false);
        }
    }

    const changeBairro = (value) => {
        if (value !== bairro) {
            setBairro(value);
            setErroBairro(false);
        }
    }

    const changeMunicipio = (value) => {
        if (value !== municipio) {
            setMunicipio(value);
            setErroMunicipio(false);
        }
    }

    const changeEstado = (value) => {
        setErroEstado(false);
        if (value !== estado) {
            if (value.value) {
                setEstado(value);
            } else {
                setEstado({ value });
            }
        }
    }

    const changeDataEmissao = (value) => {
        setErroDataEmissao(false);

        // if (value !== chaveAcesso) {
        if (value !== dataEmissao) {
            setDataEmissao(value);
            setErroDataEmissao(false);
        }
    }

    const changeSerieNf = (value) => {
        if (value !== serieNf) {
            setSerieNf(value);
            setErroSerieNf(false);
        }
    }

    const changeNumNf = (value) => {
        if (value !== numNf) {
            setNumNf(value);
            setErroNumNf(false);
        }
    }

    const changeProduto = (value, index = null) => {
        // Se o valor vier de um evento, extrair o valor do campo
        const inputValue = typeof value === 'object' && value.target ? value.target.value : value;

        if (index !== null && produtos[index]) {
            // Atualiza o nome do produto específico no array
            const novosProdutos = [...produtos];

            // Define o newProduto específico para este índice
            const novosNewProdutos = [...newProdutos];
            novosNewProdutos[index] = inputValue;
            setNewProdutos(novosNewProdutos);

            // Mantém compatibilidade com código existente
            setNewProduto(inputValue);

            // Se o usuário apagou todo o conteúdo, permitir isso
            if (!inputValue || inputValue === '') {
                novosProdutos[index] = {
                    ...novosProdutos[index],
                    nome_comercial: '',
                    fabricante: novosProdutos[index].fabricante // Mantém o fabricante
                };
            }
            // Se o valor contém o fabricante (formato "nome - fabricante")
            else if (inputValue.includes(' - ') && produtos[index].fabricante) {
                // Extrai apenas o nome do produto (parte antes do " - ")
                const nomeProduto = inputValue.split(' - ')[0];
                novosProdutos[index] = {
                    ...novosProdutos[index],
                    nome_comercial: nomeProduto
                };
            }
            // Caso contrário, assume que é apenas o nome do produto
            else {
                novosProdutos[index] = {
                    ...novosProdutos[index],
                    nome_comercial: inputValue
                };
            }

            setProdutos(novosProdutos);
        } else if (typeof value === 'object' && value.target) {
            // Caso receba um evento diretamente (compatibilidade com código existente)
            setNewProduto(inputValue);
            setProduto(inputValue);
            setErroProduto(false);
        } else if (value !== produto) {
            // Mantém compatibilidade com código existente
            setNewProduto(value);
            setProduto(value);
            setErroProduto(false);
        }
    }

    const changeUnidade = (value, index = null) => {
        if (index !== null && produtos[index]) {
            // Atualiza a unidade de um produto específico no array
            const novosProdutos = [...produtos];
            novosProdutos[index] = {
                ...novosProdutos[index],
                unidade: value
            };
            setProdutos(novosProdutos);
        } else if (value !== unidade) {
            // Mantém compatibilidade com código existente
            setUnidade(value);
            setErroUnidades(false);
        }
    }

    const changeQuantidade = (value, index = null) => {
        if (index !== null && produtos[index]) {
            // Atualiza a quantidade de um produto específico no array
            const novosProdutos = [...produtos];
            novosProdutos[index] = {
                ...novosProdutos[index],
                quantidade: value
            };
            setProdutos(novosProdutos);
        } else if (value !== quantidade) {
            // Mantém compatibilidade com código existente
            setQuantidade(value);
            setErroQuantidade(false);
        }
    }

    const changeNcmProduto = (value, index = null) => {
        if (index !== null && produtos[index]) {
            // Atualiza o NCM de um produto específico no array
            const novosProdutos = [...produtos];
            novosProdutos[index] = {
                ...novosProdutos[index],
                ncm: value
            };
            setProdutos(novosProdutos);
        } else if (value !== ncmProduto) {
            // Mantém compatibilidade com código existente
            setNcmProduto(value);
            setErroNcmProduto(false);
        }
    }

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem(USER));
        setContractSoftId(user.contract_software_id);
    }, [])

    useEffect(() => {
        setLoading(false);
    }, [props.statusEnvio])

    // Validar campos sempre que houver alterações nos valores
    useEffect(() => {
        if (showModalNFGO || showModalNFMG) validarCampos();
    }, [
        showModalNFGO,
        showModalNFMG,
        chaveAcesso,
        razaoSocial,
        cpfCnpj,
        endereco,
        bairro,
        municipio,
        estado,
        dataEmissao,
        produto,
        unidade,
        quantidade,
        ncmProduto,
        produtos,
        serieNf,
        numNf,
        relationsSicca,
        produtosSelecionadosSicca,
        quantidadesSicca,
        embalagensSicca,
        tentouEnviarNFMG
    ])

    const getEmpresa = async (setLoadingNF) => {
        try {

            const user = JSON.parse(localStorage.getItem(USER));

            const response = await api.get(`/filiais/${user.agro_subsidiary_id}`);

            if (response) {
                const filial = response.data.data;

                changeRazaoSocial(filial.razao_social);
                changeCpfCnpj(filial.cnpj);
                changeEndereco(filial.endereco);
                changeBairro(filial.bairro);
                changeMunicipio(filial.cidade);
                changeEstado(filial.estado);

                setLoadingNF(false);
                setLoadingNFGO(false);
            }

        } catch (error) {
            setLoadingNF(false);
            setLoadingNFGO(false);
        }
    }

    const [receitaAtual, setReceitaAtual] = useState(null);

    useEffect(() => {
        if (showModalNFGO) {
            getEmpresa(setLoadingNFGO);
        }
        if (showModalNFMG) {
            getEmpresa(setLoadingNFMG);
        }
    }, [showModalNFGO, showModalNFMG]);

    useEffect(() => {
        if (props.dataReceita && Array.isArray(props.dataReceita)) {
            const receitaFiltrada = props.dataReceita.filter(item => item.id === props.receitaId);
            if (receitaFiltrada.length > 0) {
                setReceitaAtual(receitaFiltrada[0]);
            }
        } else if (props.dataReceita && !Array.isArray(props.dataReceita)) {
            // If dataReceita is an object (not an array), set it directly
            setReceitaAtual(props.dataReceita);
        }

    }, [props.dataReceita, props.receitaId]);

    const abrirModalNFMG = async () => {
        setTentouEnviarNFMG(false);
        setErroSerieNf(false);
        setErroNumNf(false);
        setErroDataEmissao(false);
        setErroQuantidade(false);
        setSerieNf('');
        setNumNf('');
        setDataEmissao('');

        if (!receitaAtual) {
            setRelationsSicca([]);
            setProdutosSelecionadosSicca([]);
            setQuantidadesSicca([]);
            setEmbalagensSicca([]);
            setShowModalNFMG(true);
            return;
        }

        if (receitaAtual.chave_acesso) setChaveAcesso(receitaAtual.chave_acesso);
        if (receitaAtual.razao_social) setRazaoSocial(receitaAtual.razao_social);
        if (receitaAtual.cpf_cnpj) setCpfCnpj(receitaAtual.cpf_cnpj);
        if (receitaAtual.endereco) setEndereco(receitaAtual.endereco);
        if (receitaAtual.bairro) setBairro(receitaAtual.bairro);
        if (receitaAtual.municipio) setMunicipio(receitaAtual.municipio);
        if (receitaAtual.estado) setEstado(receitaAtual.estado);

        const relationsFromReceita =
            receitaAtual.agro_prescriptions_relations && receitaAtual.agro_prescriptions_relations.length > 0
                ? receitaAtual.agro_prescriptions_relations
                : (receitaAtual.nome_comercial && Array.isArray(receitaAtual.nome_comercial))
                    ? receitaAtual.nome_comercial.map((nome, index) => ({
                nome_comercial: nome,
                fabricante: receitaAtual.fabricante && receitaAtual.fabricante[index] ? receitaAtual.fabricante[index] : '',
                quantidade_adquirir: receitaAtual.quantidade_adquirir && receitaAtual.quantidade_adquirir[index] ? receitaAtual.quantidade_adquirir[index] : '',
                unidade_quantidade_adquirir: receitaAtual.dose_unidade && receitaAtual.dose_unidade[index] ? receitaAtual.dose_unidade[index].split('/')[0] : '',
                dose: receitaAtual.dose && receitaAtual.dose[index] ? receitaAtual.dose[index] : '',
                dose_unidade: receitaAtual.dose_unidade && receitaAtual.dose_unidade[index] ? receitaAtual.dose_unidade[index] : ''
            }))
                    : [];

        const normalizedRelations = relationsFromReceita.map((r) => ({
            ...r,
            unidadeQuantidadeAdquirir:
                r.unidadeQuantidadeAdquirir ||
                r.unidade_quantidade_adquirir ||
                r.unidadeQuantidade ||
                r.unidade ||
                ''
        }));

        setRelationsSicca(normalizedRelations);
        setProdutosSelecionadosSicca(
            normalizedRelations.map((r) => {
                const nome = r.nome_comercial || '';
                const fab = r.fabricante || '';
                return fab ? `${nome} - ${fab}` : nome;
            })
        );
        setQuantidadesSicca(
            normalizedRelations.map((r) => (r.quantidade_adquirir !== undefined && r.quantidade_adquirir !== null ? r.quantidade_adquirir : ''))
        );
        setEmbalagensSicca(new Array(normalizedRelations.length).fill(null));

        // NF de MG pode já ter sido capturada automático via webhook da Omie antes do
        // usuário abrir esse modal manual - busca e pré-preenche série/número/data em vez
        // de pedir pra digitar de novo o que o sistema já sabe (mesmo padrão do BA).
        if (receitaAtual.id) {
            try {
                const response = await api.get(`/receitas/nf/${receitaAtual.id}`);
                const nfData = response?.data?.data;
                if (nfData?.serie) setSerieNf(String(nfData.serie));
                if (nfData?.nf) setNumNf(String(nfData.nf).replace(/\D+/g, ''));
                if (nfData?.data_emissao) setDataEmissao(String(nfData.data_emissao).slice(0, 10));
            } catch (_) {
                // sem NF prévia (Omie) ou falha ao consultar - segue com campos vazios, usuário digita manual
            }
        }

        setShowModalNFMG(true);
    };

    // useEffect(() => {
    //     const handler = (event) => {
    //         const receitaId = event?.detail?.receitaId;
    //         if (receitaId && receitaId === props.receitaId) {
    //             abrirModalNFMG();
    //         }
    //     };

    //     window.addEventListener('mg_nf_open', handler);
    //     return () => window.removeEventListener('mg_nf_open', handler);
    // }, [props.receitaId, receitaAtual]);

    // Helpers de validação
    const parseDateFlex = (s) => {
        if (!s) return null;
        const trimmed = String(s).trim();

        // dd/mm/yyyy
        if (trimmed.includes('/')) {
            const [dd, mm, yyyy] = trimmed.split('/');
            const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            return isNaN(d) ? null : d;
        }

        // yyyy-mm-dd ou ISO
        const iso = new Date(trimmed);
        if (!isNaN(iso)) return iso;

        // yyyy-mm-ddTHH:mm:ss -> pegar só yyyy-mm-dd
        const parts = trimmed.split('-');
        if (parts.length >= 3) {
            const day = parts[2].slice(0, 2);
            const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(day));
            return isNaN(d) ? null : d;
        }
        return null;
    };

    const isNumericStr = (v) => /^\d+([.,]\d+)?$/.test(String(v).trim());
    const isDigitsOnly = (v) => /^\d+$/.test(String(v).trim());

    const calcularValidadeNFMG = () => {
        const serieOk = String(serieNf || '').trim() !== '';
        const numStr = String(numNf || '').trim();
        const numOk = numStr !== '' && isDigitsOnly(numStr);

        const receitaEmissaoStr =
            (receitaAtual && receitaAtual.data_emissao) ||
            (props.dataReceita && props.dataReceita.data_emissao) ||
            '';

        const nfEmissaoStr = dataEmissao || '';
        const receitaDate = parseDateFlex(receitaEmissaoStr);
        const nfDate = parseDateFlex(nfEmissaoStr);

        const dataOk = Boolean(nfDate) && (!receitaDate || nfDate >= receitaDate);

        const qtdsOk =
            Array.isArray(quantidadesSicca) &&
            quantidadesSicca.length === relationsSicca.length &&
            quantidadesSicca.every((q) => Number.isInteger(Number(q)) && Number(q) > 0);

        const embalagensOk =
            Array.isArray(embalagensSicca) &&
            embalagensSicca.length === relationsSicca.length &&
            embalagensSicca.every((e) => {
                if (!e) return false;
                if (typeof e === 'object') return Boolean(e.value);
                return String(e).trim() !== '';
            });

        const valido = serieOk && numOk && dataOk && qtdsOk && embalagensOk;
        setFormValido(valido);
        return {
            valido,
            serieOk,
            numOk,
            receitaDate,
            nfDate,
            qtdsOk,
            embalagensOk
        };
    };

    // Função para validar todos os campos obrigatórios
    const validarCampos = () => {
        let valido = true;

        if (showModalNFMG) {
            const {
                valido: validoMG,
                serieOk,
                numOk,
                receitaDate,
                nfDate,
                qtdsOk,
                embalagensOk
            } = calcularValidadeNFMG();

            if (tentouEnviarNFMG) {
                setErroSerieNf(!serieOk);
                setErroNumNf(!numOk);

                const dataInvalida = Boolean(dataEmissao) && nfDate && receitaDate && nfDate < receitaDate;
                setErroDataEmissao(dataInvalida);

                setErroQuantidade(!(qtdsOk && embalagensOk));
            } else {
                setErroSerieNf(false);
                setErroNumNf(false);
                setErroDataEmissao(false);
                setErroQuantidade(false);
            }

            return Boolean(validoMG);
        }

        // Validação dos campos da nota fiscal
        if (chaveAcesso) {
            const chaveAcessoSemEspacos = chaveAcesso.replace(/\s+/g, '');
            if (chaveAcessoSemEspacos.length !== 44) {
                setErroChaveAcesso(true);
                valido = false;
            } else {
                setErroChaveAcesso(false);
            }
        }

        if (!razaoSocial || razaoSocial.trim() === '') {
            setErroRazaoSocial(true);
            valido = false;
        } else {
            setErroRazaoSocial(false);
        }

        if (!cpfCnpj || cpfCnpj.trim() === '') {
            setErroCpfCnpj(true);
            valido = false;
        } else if (erroCpfCnpj) {
            // já sinalizado como inválido pela validação em tempo real (changeCpfCnpj)
            valido = false;
        } else {
            setErroCpfCnpj(false);
        }

        if (!endereco || endereco.trim() === '') {
            setErroEndereco(true);
            valido = false;
        } else {
            setErroEndereco(false);
        }

        if (!bairro || bairro.trim() === '') {
            setErroBairro(true);
            valido = false;
        } else {
            setErroBairro(false);
        }

        if (!municipio || municipio.trim() === '') {
            setErroMunicipio(true);
            valido = false;
        } else {
            setErroMunicipio(false);
        }

        if (!estado || (typeof estado === 'object' && !estado.value)) {
            setErroEstado(true);
            valido = false;
        } else {
            setErroEstado(false);
        }

        // Data de emissão da NF: só mostra erro se menor que a data da receita
        const receitaEmissaoStr =
            (receitaAtual && receitaAtual.data_emissao) ||
            (props.dataReceita && props.dataReceita.data_emissao) ||
            '';

        const nfEmissaoStr = dataEmissao || '';
        const receitaDate = parseDateFlex(receitaEmissaoStr);
        const nfDate = parseDateFlex(nfEmissaoStr);

        if (dataEmissao && nfDate && receitaDate && nfDate < receitaDate) {
            setErroDataEmissao(true);
            valido = false;
        } else {
            // Não marcar vermelho quando vazio ou válido
            setErroDataEmissao(false);
            // Form continua inválido se data não preenchida
            if (!dataEmissao) {
                valido = false;
            }
        }

        // Validação dos produtos (lista ou formulário simples)
        if (produtos.length > 0) {
            // Campos obrigatórios
            const faltandoObrigatorio = produtos.some(p =>
                !p.nome_comercial || !p.unidade || !p.quantidade || !p.ncm
            );
            if (faltandoObrigatorio) {
                setErroProduto(true);
                setErroQuantidade(true);
                setErroNcmProduto(true);
                valido = false;
            } else {
                setErroProduto(false);
            }

            // Quantidade numérica e NCM só dígitos
            const qtdInvalida = produtos.some(p => p.quantidade && !isNumericStr(p.quantidade));
            const ncmInvalido = produtos.some(p => p.ncm && !isDigitsOnly(p.ncm));

            if (qtdInvalida) {
                setErroQuantidade(true);
                valido = false;
            } else {
                setErroQuantidade(false);
            }

            if (ncmInvalido) {
                setErroNcmProduto(true);
                valido = false;
            } else {
                setErroNcmProduto(false);
            }
        } else {
            // Form simples
            if (produto && produto.trim() === '') {
                setErroProduto(true);
                valido = false;
            } else {
                setErroProduto(false);
            }

            if (quantidade && !isNumericStr(quantidade)) {
                setErroQuantidade(true);
                valido = false;
            } else {
                setErroQuantidade(false);
            }

            if (ncmProduto && !isDigitsOnly(ncmProduto)) {
                setErroNcmProduto(true);
                valido = false;
            } else {
                setErroNcmProduto(false);
            }
        }

        // Form só é válido com data de emissão preenchida e todas as regras OK
        setFormValido(valido && Boolean(nfDate));
        return valido && Boolean(nfDate);
    };

    // Função para formatar os dados no formato esperado pelo backend
    const formatarDadosParaBackend = () => {
        if (showModalNFMG) {
            return {
                estado: 'MG',
                dataEmissao,
                quantidades: Array.isArray(quantidadesSicca) ? quantidadesSicca.map((q) => String(q)) : [],
                embalagens: Array.isArray(embalagensSicca)
                    ? embalagensSicca.map((e) => (typeof e === 'object' ? e.value : e))
                    : [],
                serieNf,
                numNf,
                produtosSelecionados: Array.isArray(produtosSelecionadosSicca) ? produtosSelecionadosSicca : []
            };
        }

        // Preparar os arrays de produtos
        let nome_produto = [];
        let ncm_produto = [];
        let unidade_medida = [];
        let qtd_produto = [];

        // Se temos produtos no array, usamos eles
        if (produtos.length > 0) {
            produtos.forEach(p => {
                nome_produto.push(p.nome_comercial || '');
                ncm_produto.push(p.ncm || '');
                unidade_medida.push(typeof p.unidade === 'object' ? p.unidade.value : p.unidade || '');
                qtd_produto.push(p.quantidade || '');
            });
        } else {
            // Caso contrário, usamos os campos individuais
            nome_produto.push(produto || '');
            ncm_produto.push(ncmProduto || '');
            unidade_medida.push(typeof unidade === 'object' ? unidade.value : unidade || '');
            qtd_produto.push(quantidade || '');
        }

        // Formatar os dados conforme o payload esperado pelo backend
        const dadosFormatados = {
            chave_acesso: chaveAcesso ? chaveAcesso.replace(/\s+/g, '') : '',
            razao_social_emissor: razaoSocial,
            cpf_cnpj_emissor: cpfCnpj,
            endereco_emissor: endereco,
            bairro_emissor: bairro,
            municipio_emissor: municipio,
            uf_emissor: typeof estado === 'object' ? estado.value : estado,
            data_emissao_nf: dataEmissao,
            nome_produto,
            ncm_produto,
            unidade_medida,
            qtd_produto
        };

        return dadosFormatados;
    };

    // Função para exibir os valores da nota fiscal no console
    const exibirValoresNoConsole = () => {
        const dadosNotaFiscal = {
            chaveAcesso,
            razaoSocial,
            cpfCnpj,
            endereco,
            bairro,
            municipio,
            estado: typeof estado === 'object' ? estado.value : estado,
            dataEmissao,
            produtos: produtos.length > 0 ? produtos : [
                {
                    nome_comercial: produto,
                    unidade: typeof unidade === 'object' ? unidade.value : unidade,
                    quantidade,
                    ncm: ncmProduto
                }
            ]
        };

        const dadosFormatados = formatarDadosParaBackend();

        return dadosFormatados;
    };

    const abrirFormularioNF = () => {
        setShowModalPrazoGO(false);
        setShowModalNFGO(true);

        if (!receitaAtual) return;

        if (receitaAtual.chave_acesso) setChaveAcesso(receitaAtual.chave_acesso);
        if (receitaAtual.razao_social) setRazaoSocial(receitaAtual.razao_social);
        if (receitaAtual.cpf_cnpj) setCpfCnpj(receitaAtual.cpf_cnpj);
        if (receitaAtual.endereco) setEndereco(receitaAtual.endereco);
        if (receitaAtual.bairro) setBairro(receitaAtual.bairro);
        if (receitaAtual.municipio) setMunicipio(receitaAtual.municipio);
        if (receitaAtual.estado) setEstado(receitaAtual.estado);

        if (receitaAtual.agro_prescriptions_relations && receitaAtual.agro_prescriptions_relations.length > 0) {
            const produtosArray = receitaAtual.agro_prescriptions_relations.map((r) => ({
                ...r,
                unidade: mapUnidadeMedidaNf(r.unidade_quantidade_adquirir),
            }));
            setProdutos(produtosArray);
            setProduto(produtosArray[0].nome_comercial || '');
            setUnidade(produtosArray[0].unidade || '');
        } else if (receitaAtual.nome_comercial && Array.isArray(receitaAtual.nome_comercial)) {
            const produtosArray = receitaAtual.nome_comercial.map((nome, index) => {
                const unidadeDb = receitaAtual.unidade_quantidade_adquirir && receitaAtual.unidade_quantidade_adquirir[index]
                    ? receitaAtual.unidade_quantidade_adquirir[index]
                    : '';
                return {
                    nome_comercial: nome,
                    fabricante: receitaAtual.fabricante && receitaAtual.fabricante[index] ? receitaAtual.fabricante[index] : '',
                    quantidade_adquirir: receitaAtual.quantidade_adquirir && receitaAtual.quantidade_adquirir[index] ? receitaAtual.quantidade_adquirir[index] : '',
                    unidade_quantidade_adquirir: unidadeDb,
                    unidade: mapUnidadeMedidaNf(unidadeDb),
                    dose: receitaAtual.dose && receitaAtual.dose[index] ? receitaAtual.dose[index] : '',
                    dose_unidade: receitaAtual.dose_unidade && receitaAtual.dose_unidade[index] ? receitaAtual.dose_unidade[index] : ''
                };
            });
            setProdutos(produtosArray);
            if (produtosArray.length > 0) {
                setProduto(produtosArray[0].nome_comercial || '');
                setUnidade(produtosArray[0].unidade || '');
                setQuantidade(produtosArray[0].quantidade_adquirir || '');
            }
        }
    };

    // Função para lidar com o envio da nota fiscal
    const enviarNotaFiscal = async () => {
        if (showModalNFMG) {
            setTentouEnviarNFMG(true);
        }

        if (showModalNFMG && (!receitaAtual || !receitaAtual.id)) {
            store.addNotification({
                title: "Erro!",
                message: "Não foi possível identificar o id da receita.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        if (showModalNFBA) {
            const id = (receitaAtual && receitaAtual.id) || props.receitaId;
            if (!id) {
                store.addNotification({
                    title: "Erro!",
                    message: "Não foi possível identificar o id da receita.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
                return;
            }
            const num = String(numNFBA || '').trim();
            if (!num) {
                setErroNumNFBA(true);
                return;
            }
            try {
                setLoadingSendNF(true);
                const response = await api.post(`/receitas/exportar_nf/${id}`, { numNf: num, estado: 'BA' });
                if (response.status === 200 || response.status === 201) {
                    setShowModalNFBA(false);
                    store.addNotification({
                        title: "Sucesso!",
                        message: "Nota fiscal enviada com sucesso!",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: { duration: 4000, onScreen: true }
                    });
                    if (props.updateReceitas) {
                        props.updateReceitas();
                    }
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
            } finally {
                setLoadingSendNF(false);
            }
            return;
        }

        if (validarCampos()) {
            try {
                setLoadingSendNF(true);
                const payload = formatarDadosParaBackend();

                const endpoint = showModalNFMG
                    ? `/sicca/exportar_nf/${receitaAtual.id}`
                    : pathExportarNf(props.estado, receitaAtual.id);
                const response = await api.post(endpoint, payload);

                if (response.status === 200 || response.status === 201) {
                    setLoadingSendNF(false);
                    setShowModalPrazoGO(false);
                    setShowModalNFGO(false)
                    setShowModalNFMG(false)

                    store.addNotification({
                        title: "Sucesso!",
                        message: "Nota fiscal enviada com sucesso!",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });

                    if (props.updateReceitas) {
                        props.updateReceitas();
                    }
                }
            } catch (error) {
                setShowModalPrazoGO(false);
                setShowModalNFGO(false);
                setShowModalNFMG(false);
                setNewProduto(null);
                setNewProdutos([]);
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                setLoadingSendNF(false);
            } finally {
                setLoadingSendNF(false);
            }

        }
    };

      const tooltipContentLocation = (
        <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
            <p><strong>Endereço:</strong> </p>
        </div>
    );

    // NF de BA pode já ter sido capturada automático via webhook da Omie antes do
    // usuário abrir esse modal manual - busca e pré-preenche em vez de pedir pra
    // digitar de novo o que o sistema já sabe.
    const openModalNFBA = async () => {
        setShowModalNFBA(true);
        try {
            const id = (receitaAtual && receitaAtual.id) || props.receitaId;
            const response = await api.get(`/receitas/nf/${id}`);
            const nf = response?.data?.data?.nf;
            if (nf) {
                setNumNFBA(String(nf).replace(/\D+/g, ''));
                setErroNumNFBA(false);
            }
        } catch (_) {
            // sem NF prévia ou falha ao consultar - segue com campo vazio, usuário digita manual
        }
    };

    const handleNfClick = async () => {
        if (typeof props.onNfHomologar !== 'function') return;
        setLoading(true);
        try {
            await props.onNfHomologar();
        } catch (_) {
            // error notification handled inside onNfHomologar
        } finally {
            setLoading(false);
        }
    };

    const preencherEAbrirFormularioNFGO = () => {
        setShowModalNFGO(true);

        // Preenche campos com a receita selecionada
        if (receitaAtual) {
            if (receitaAtual.chave_acesso) setChaveAcesso(receitaAtual.chave_acesso);
            if (receitaAtual.razao_social) setRazaoSocial(receitaAtual.razao_social);
            if (receitaAtual.cpf_cnpj) setCpfCnpj(receitaAtual.cpf_cnpj);
            if (receitaAtual.endereco) setEndereco(receitaAtual.endereco);
            if (receitaAtual.bairro) setBairro(receitaAtual.bairro);
            if (receitaAtual.municipio) setMunicipio(receitaAtual.municipio);
            if (receitaAtual.estado) setEstado(receitaAtual.estado);

            if (receitaAtual.agro_prescriptions_relations && receitaAtual.agro_prescriptions_relations.length > 0) {
                const produtosArray = receitaAtual.agro_prescriptions_relations.map((r) => ({
                    ...r,
                    unidade: mapUnidadeMedidaNf(r.unidade_quantidade_adquirir),
                }));
                setProdutos(produtosArray);
                setProduto(produtosArray[0].nome_comercial || '');
                setUnidade(produtosArray[0].unidade || '');
            } else if (receitaAtual.nome_comercial && Array.isArray(receitaAtual.nome_comercial)) {
                const produtosArray = receitaAtual.nome_comercial.map((nome, index) => {
                    const unidadeDb = receitaAtual.unidade_quantidade_adquirir && receitaAtual.unidade_quantidade_adquirir[index]
                        ? receitaAtual.unidade_quantidade_adquirir[index]
                        : '';
                    return {
                    nome_comercial: nome,
                    fabricante: receitaAtual.fabricante && receitaAtual.fabricante[index] ? receitaAtual.fabricante[index] : '',
                    quantidade_adquirir: receitaAtual.quantidade_adquirir && receitaAtual.quantidade_adquirir[index] ? receitaAtual.quantidade_adquirir[index] : '',
                    unidade_quantidade_adquirir: unidadeDb,
                    unidade: mapUnidadeMedidaNf(unidadeDb),
                    dose: receitaAtual.dose && receitaAtual.dose[index] ? receitaAtual.dose[index] : '',
                    dose_unidade: receitaAtual.dose_unidade && receitaAtual.dose_unidade[index] ? receitaAtual.dose_unidade[index] : ''
                };
                });
                setProdutos(produtosArray);
                if (produtosArray.length > 0) {
                    setProduto(produtosArray[0].nome_comercial || '');
                    setUnidade(produtosArray[0].unidade || '');
                    setQuantidade(produtosArray[0].quantidade_adquirir || '');
                }
            }
        }
    };

    return (
        <>
            {loading ? (
                <div style={{ height: '30px', display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                    <Loading size="20px" noMargin />
                </div>
            ) : (
                <S.BtnHomolog
                    style={props.style}
                    nf={props.nf}
                    estado={props.estado}
                    homologado={props.homologado}
                    statusEnvio={props.statusEnvio}
                    status={props.homologado === 2 ? props.homologado : props.statusEnvio}
                    onClick={() => {
                        if (typeof props.onNfHomologar === 'function') {
                            handleNfClick();
                            return;
                        }

                        if (props.estado === 'MG') {
                            return;
                        }

                        if (isNfAposReceita(props.estado) && props.homologado === 3) {
                            // Avisa do prazo de 7 dias expirado já no clique do botão,
                            // antes de abrir o formulário - antes disso o aviso só
                            // aparecia depois de preencher tudo e tentar enviar.
                            if (isPrazoExpiradoGO()) {
                                setShowModalPrazoGOAviso(true);
                                return;
                            }

                            preencherEAbrirFormularioNFGO();

                            // Impede chamar exportarReceita quando estamos no fluxo de NF GO
                            return;
                        }

                        if (props.estado === 'BA' && props.homologado === 2) {
                            openModalNFBA();
                            return;
                        }

                        // Demais estados ou homologações diferentes: segue o fluxo normal
                        exportarReceita(props.receitaId, props.estado)
                    }}
                >
                    <Tooltip
                    content={
                        <div style={{ textAlign: 'left', padding: '10px', maxWidth: '300px' }}>
                            <p>
                                {
                                    props.onNfHomologar ? (
                                        props.homologado === 1 ? `Enviado` :
                                        props.homologado === 2 ? `Clique para enviar novamente` :
                                        `Não enviado`
                                    ) :
                                    //Verificado
                                    isNfAposReceita(props.estado) && props.homologado === 0 ? `Clique para enviar novamente` :
                                    isNfAposReceita(props.estado) && props.homologado === 1 ? `Enviado` :
                                    isNfAposReceita(props.estado) && props.homologado === 2 ? `Clique para enviar novamente` :
                                    isNfAposReceita(props.estado) && props.homologado === 3 ? `Clique para enviar a Nota Fiscal` :
                                    isNfAposReceita(props.estado) && props.statusEnvio === 4 ? `Clique para enviar novamente` :
                                    showTotvsNf ? `NF enviada` :
                                    //
                                    props.estado === 'BA' && props.homologado === 0 ? `Enviado` :
                                    props.estado === 'BA' && props.homologado === 3 ? `Clique para enviar a Nota Fiscal` :
                                    //
                                    // MG não tem ação de clique própria aqui (ver onClick abaixo),
                                    // então o tooltip só informa o status, sem convidar a clicar.
                                    props.estado === 'MG' && props.homologado === 1 ? `NF anexada` :
                                    (props.estado === 'MG' && (props.homologado === 3 || props.homologado === 0)) ? `NF pendente` :
                                    //
                                    // A ordem aqui espelha a do badge (mais abaixo): `homologado` e a
                                    // fonte de verdade, e `statusEnvio` (status_homologacao) so refina o
                                    // caso homologado === 0. Nao inverta - getStatusEnvioReceita devolve
                                    // statusEnvio = 3 ("enviado") para toda receita de envio manual
                                    // (envio_automatico = 0), que na verdade nunca foi enviada.
                                    // Erro so aparece enquanto a receita nao foi aceita (homologado !== 1),
                                    // senao uma receita reenviada com sucesso ficaria exibindo erro antigo.
                                    props.estado === 'MT' && props.homologado !== 1 && props.homologacaoErro ? props.homologacaoErro :
                                    props.estado === 'MT' && props.homologado === 1 ? `Enviado` :
                                    props.estado === 'MT' && props.homologado === 2 ? `Enviando` :
                                    props.estado === 'MT' && props.statusEnvio === 0 ? `Prazo expirado` :
                                    props.estado === 'MT' && props.statusEnvio === 4 ? `Clique para enviar novamente` :
                                    props.estado === 'MT' && props.homologado === 0 ? `Clique para enviar novamente` :
                                    props.estado === 'MT' && props.statusEnvio === 3 ? `Enviado` :
                                    //
                                    props.estado === 'ES' && props.homologado === 0 ? `Não enviado` :
                                    props.estado === 'ES' && props.homologado === 1 ? `Enviado` :
                                    props.estado === 'ES' && props.homologado === 2 ? `Enviando` :
                                    props.estado === 'ES' && props.statusEnvio === 4 ? `Clique para enviar novamente` :
                                    //
                                    props.estado === 'SC' && props.homologado === 0 ? `Não enviado` :
                                    props.estado === 'SC' && props.homologado === 1 ? `Enviado` :
                                    props.estado === 'SC' && props.homologado === 2 ? `Enviando` :
                                    props.estado === 'SC' && props.statusEnvio === 4 ? `Clique para enviar novamente` :
                                    //
                                    props.estado === 'RS' && props.homologado === 0 ? `Não enviado` :
                                    props.estado === 'RS' && props.homologado === 1 ? `Enviado` :
                                    props.estado === 'RS' && props.homologado === 2 ? `Enviando` :
                                    props.estado === 'RS' && props.statusEnvio === 4 ? `Clique para enviar novamente` :
                                    //
                                    props.statusReceita === 1 ? `Receita emitida` :
                                    props.statusReceita === 0 ? `Receita cancelada` : ''
                                }
                            </p>
                        </div>
                    }
                    animation="fade"
                    delay={[100, 100]}
                    arrow={true}
                    theme="light"
                    placement="bottom"
                >
                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', cursor: 'pointer' }}
                        onClick={(e) => {
                            if (props.estado === 'MG') {
                                e.stopPropagation();
                                if (props.homologado !== 0 && props.homologado !== 2 && props.homologado !== 3) return;
                                abrirModalNFMG();
                                return;
                            }
                            if (props.estado === 'BA' && props.homologado === 3) {
                                e.stopPropagation();
                                openModalNFBA();
                                return;
                            }
                        }}
                    >
                  <img
                    className='status-icon'
                    src={
                        props.onNfHomologar ? (
                            props.homologado === 1 ? status3 :
                            props.homologado === 2 ? status2 :
                            status0
                        ) :
                        isNfAposReceita(props.estado) && props.homologado === 0 ? status0 :
                        isNfAposReceita(props.estado) && props.homologado === 1 ? status3 :
                        isNfAposReceita(props.estado) && props.homologado === 2 ? status2 :
                        isNfAposReceita(props.estado) && props.homologado === 3 ? status4 :
                        isNfAposReceita(props.estado) && props.statusEnvio === 4 ? status0 :
                        //
                        props.estado === 'BA' && props.homologado === 0 ? status3 :
                        props.estado === 'BA' && props.homologado === 3 ? status4 :
                        //
                        props.estado === 'MG' && props.homologado === 1 ? status3 :
                        props.estado === 'MG' && props.homologado === 3 && props.nf ? status0 :
                        // homologado === 0 no MG só ocorre em receitas antigas, criadas
                        // antes de MG passar a nascer com homologado 3 - na prática é a
                        // mesma situação (NF nunca foi anexada), então tratamos igual.
                        (props.estado === 'MG' && (props.homologado === 3 || props.homologado === 0)) ? status4 :
                        //
                        props.estado === 'MT' && props.homologado === 0 ? status0 :
                        props.estado === 'MT' && props.homologado === 1 ? status3 :
                        props.estado === 'MT' && props.homologado === 2 ? status2 :
                        props.estado === 'MT' && props.statusEnvio === 4 ? status0 :
                        //
                        props.estado === 'SC' && props.homologado === 0 ? status0 :
                        props.estado === 'SC' && props.homologado === 1 ? status3 :
                        props.estado === 'SC' && props.homologado === 2 ? status2 :
                        props.estado === 'SC' && props.statusEnvio === 4 ? status0 :
                        //
                        props.estado === 'ES' && props.homologado === 0 ? status0 :
                        props.estado === 'ES' && props.homologado === 1 ? status3 :
                        props.estado === 'ES' && props.homologado === 2 ? status2 :
                        props.estado === 'ES' && props.statusEnvio === 4 ? status0 :
                        //
                        props.estado === 'RS' && props.homologado === 0 ? status0 :
                        props.estado === 'RS' && props.homologado === 1 ? status3 :
                        props.estado === 'RS' && props.homologado === 2 ? status2 :
                        props.estado === 'RS' && props.statusEnvio === 4 ? status0 :
                        // Demais estados (AC, AL, AM, AP, CE, DF, MA, MG, MS, PA, PB, PE, PI, PR, RJ, RN, RO, RR, SE, SP, TO)
                        // sem homologação estadual própria - só indica se a NF foi anexada.
                        // Fica por último pra não tampar o status de homologação dos estados acima.
                        props.estado && props.nf ? status3 :
                        // Sem homologação estadual e sem exigência de NF: reflete o ciclo
                        // de vida da própria receita (emitida ou cancelada).
                        props.statusReceita === 1 ? status3 :
                        props.statusReceita === 0 ? status0 : ""
                    }
                    alt='' />

                <TaglinePSpan>
                    {
                        props.onNfHomologar ? (
                            props.homologado === 1 ? `Enviado` :
                            props.homologado === 2 ? `Pendente` :
                            `Erro`
                        ) :
                        isNfAposReceita(props.estado) && props.homologado === 0 ? `Não enviado para ${orgaoHomologacaoNfAposReceita(props.estado)}` :
                        isNfAposReceita(props.estado) && props.homologado === 1 ? `Enviado para ${orgaoHomologacaoNfAposReceita(props.estado)}` :
                        isNfAposReceita(props.estado) && props.homologado === 2 ? `Enviando para ${orgaoHomologacaoNfAposReceita(props.estado)}` :
                        isNfAposReceita(props.estado) && props.homologado === 3 ? `NF PENDENTE` :
                        isNfAposReceita(props.estado) && props.statusEnvio === 4 ? `Não enviado para ${orgaoHomologacaoNfAposReceita(props.estado)}` :
                        //
                        props.estado === 'BA' && props.homologado === 0 ? `NF ANEXADA` :
                        props.estado === 'BA' && props.homologado === 3 ? `NF PENDENTE` :
                        //
                        props.estado === 'MG' && props.homologado === 1 ? `NF ANEXADA` :
                        props.estado === 'MG' && props.homologado === 3 && props.nf ? `COMPLETAR DADOS DA NF` :
                        (props.estado === 'MG' && (props.homologado === 3 || props.homologado === 0)) ? `NF PENDENTE` :
                        //
                        props.estado === 'MT' && props.homologado === 0 ? (props.homologacaoErro ? getTituloErroSisdevMT(props.homologacaoErro) : `Não enviado para SISDEV`) :
                        props.estado === 'MT' && props.homologado === 1 ? `Enviado para SISDEV` :
                        props.estado === 'MT' && props.homologado === 2 ? `Enviando para SISDEV` :
                        props.estado === 'MT' && props.statusEnvio === 4 ? (props.homologacaoErro ? getTituloErroSisdevMT(props.homologacaoErro) : `Não enviado para SISDEV`) :
                        //
                        props.estado === 'SC' && props.homologado === 0 ? `Não enviado para SIGEN` :
                        props.estado === 'SC' && props.homologado === 1 ? `Enviado para SIGEN` :
                        props.estado === 'SC' && props.homologado === 2 ? `Enviando para SIGEN` :
                        props.estado === 'SC' && props.statusEnvio === 4 ? `Não enviado para SIGEN` :
                        //
                        props.estado === 'ES' && props.homologado === 0 ? `Não enviado para IDAF` :
                        props.estado === 'ES' && props.homologado === 1 ? `Enviado para IDAF` :
                        props.estado === 'ES' && props.homologado === 2 ? `Enviando para IDAF` :
                        props.estado === 'ES' && props.statusEnvio === 4 ? `Não enviado para IDAF` :
                        //
                        props.estado === 'RS' && props.homologado === 0 ? `Não enviado para RS` :
                        props.estado === 'RS' && props.homologado === 1 ? `Enviado para RS` :
                        props.estado === 'RS' && props.homologado === 2 ? `Enviando para RS` :
                        props.estado === 'RS' && props.statusEnvio === 4 ? `Não enviado para RS` :
                        // Demais estados sem homologação estadual própria - só indica NF anexada.
                        // Por último pra não tampar o status de homologação (GO/BA/MG/MT/SC/ES/RS).
                        props.estado && props.nf ? `NF ANEXADA` :
                        // Sem homologação estadual e sem exigência de NF: reflete o ciclo
                        // de vida da própria receita (emitida ou cancelada).
                        props.statusReceita === 1 ? `EMITIDA` :
                        props.statusReceita === 0 ? `CANCELADA` : ""
                    }
                </TaglinePSpan>
                </div>
                  </Tooltip>
                </S.BtnHomolog>
            )}

            <ModalAlert
                show={showModalBlock}
                onHide={() => {
                    setShowModalBlock(false);
                    setNewProduto(null);
                    setNewProdutos([]);
                }}
            >
                <h4 style={{
                    textAlign: 'center'
                }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                }}>
                    Para não comprometer o controle de suas receitas agronômicas durante o período de teste esta função é bloqueada.
                </p>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                }}>
                    Assine o AgroReceita para desbloquear esta função!
                </p>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='VER PLANOS'
                        outline={false}
                        disabled={false}
                        onClick={() => openPlanos(false)}
                        loading={false}
                    />
                </div>
            </ModalAlert>

            <ModalAlert
                show={showModalExport}
                onHide={() => {
                    setModalExport(false);
                    setNewProduto(null);
                    setNewProdutos([]);
                }}
                title="Exportação de Receita com Atraso"
            >
                <h2 style={{
                    width: '100%',
                    textAlign: 'center',
                    marginBottom: '20px',
                    fontSize: '22px'
                }}>Descreva o motivo para o atraso da exportação</h2>

                <div style={{
                    width: '100%',
                    padding: '2% 20%',
                    margin: 'auto'
                }}>
                    <Input
                        id="motivoatraso"
                        label="Motivo"
                        value={motivoAtraso}
                        maxlength="5000"
                        onChange={(e) => setMotivoAtraso(e)}
                        onBlur={(e) => setMotivoAtraso(e.target.value)}
                    />


                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                        <Button
                            width='296px'
                            height='50px'
                            value='ENVIAR'
                            outline={false}
                            disabled={motivoAtraso.trim() === '' ? true : false}
                            onClick={() => validarMotivo(idReceitaExport, estadoReceitaExport, file64)}
                            loading={loading}
                        />
                    </div>
                </div>
            </ModalAlert>

            <ModalAlert
                show={showModalUpload}
                onHide={() => {
                    setModalUpload(false);
                    setNewProduto(null);
                    setNewProdutos([]);
                }}
            >
                <h4 style={{
                    textAlign: 'center'
                }}>Enviar receita assinada pelo responsável técnico</h4>
                <StyleModal style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                }}>
                    <div className="arquivos">
                        <label
                            className='btn-update'
                            for='input-file'
                            multiple
                            onClick={() => { setFile64(true) }}
                        >
                            Selecionar arquivo
                        </label>
                        <label className="arq-name" style={{ width: '330px' }}>
                            {namesfiles.length > 0 ?
                                (<>
                                    {namesfiles}
                                    <img src={mais} width="20" height="20" onClick={() => deleteFile()} />
                                </>) : "Nenhum arquivo selecionado"}
                        </label>

                        {file64 ? (
                            <input
                                style={{ display: "none" }}
                                type="file"
                                id="input-file"
                                name="file"
                                multiple
                                onChange={(e) => uploadArquivo(e)}
                            />
                        ) : (null)}
                    </div>
                </StyleModal>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '10px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='ENVIAR'
                        outline={false}
                        disabled={typeof file64 == 'string' ? file64 !== '' ? false : true : true}
                        onClick={(e) => validarArquivo(e)}
                        loading={false}
                    />
                </div>
            </ModalAlert>

            <ModalGenericV2
                show={showModalPrazoGO}
                onHide={() => {
                    if (!loadingSendNF) setShowModalPrazoGO(false);
                }}
                marginBottom="0"
            >
                <div style={{
                    width: '100%',
                    maxWidth: '525px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    paddingBottom: '24px',
                }}>
                    <H5>Prazo expirado para homologação no {orgaoHomologacaoNfAposReceita(props.estado)}</H5>
                    <BodyG>
                        O prazo de envio de 7 dias após a emissão expirou. Você pode enviar mesmo assim, porém a responsabilidade será do responsável técnico.
                    </BodyG>
                    <div style={{
                        width: '100%',
                        height: 'auto',
                        gap: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ButtonV2
                            width="140px"
                            height="40px"
                            value="CANCELAR"
                            outline={true}
                            disabled={loadingSendNF}
                            color="#26212F"
                            onClick={() => setShowModalPrazoGO(false)}
                            loading={false}
                        />
                        <ButtonV2
                            width="140px"
                            height="40px"
                            value="ENVIAR"
                            outline={false}
                            disabled={loadingSendNF}
                            onClick={abrirFormularioNF}
                            loading={loadingSendNF}
                        />
                    </div>
                </div>
            </ModalGenericV2>

            <ModalGenericV2
                show={showModalPrazoGOAviso}
                onHide={() => setShowModalPrazoGOAviso(false)}
                marginBottom="0"
            >
                <div style={{
                    width: '100%',
                    maxWidth: '525px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    paddingBottom: '24px',
                }}>
                    <H5>Prazo expirado para homologação no {orgaoHomologacaoNfAposReceita(props.estado)}</H5>
                    <BodyG>
                        O prazo de envio de 7 dias após a emissão expirou. Você pode enviar mesmo assim, porém a responsabilidade será do responsável técnico.
                    </BodyG>
                    <div style={{
                        width: '100%',
                        height: 'auto',
                        gap: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ButtonV2
                            width="140px"
                            height="40px"
                            value="CANCELAR"
                            outline={true}
                            color="#26212F"
                            onClick={() => setShowModalPrazoGOAviso(false)}
                            loading={false}
                        />
                        <ButtonV2
                            width="140px"
                            height="40px"
                            value="CONTINUAR"
                            outline={false}
                            onClick={() => {
                                setShowModalPrazoGOAviso(false);
                                preencherEAbrirFormularioNFGO();
                            }}
                            loading={false}
                        />
                    </div>
                </div>
            </ModalGenericV2>

            <ModalGeneric
                show={showModalNFGO && !loadingNFGO && !showModalPrazoGO}
                onHide={() => {
                    setShowModalNFGO(false);
                    setNewProduto(null);
                    setNewProdutos([]);
                }}
                marginBottom='0'
            >

                <S.ContainerModal>
                    <H5>Dados da Nota Fiscal</H5>

                    <S.ContainerNFInfo>
                        <S.ContainerNF>
                            <Input
                                marginBottom='0px'
                                name="nfkey"
                                type="text"
                                id="chaveacesso"
                                label="Chave de acesso"
                                onChange={e => changeChaveAcesso(e)}
                                messageErro="A chave de acesso precisa conter 44 digitos."
                                erro={erroChaveAcesso}
                                value={chaveAcesso}
                                onBlur={() => {
                                    // Remove espaços para validação correta do comprimento
                                    const chaveAcessoSemEspacos = chaveAcesso.replace(/\s+/g, '');
                                    if (chaveAcessoSemEspacos.length === 44) {
                                        setErroChaveAcesso(false);
                                    } else {
                                        setErroChaveAcesso(true);
                                    }
                                }}
                            />
                            <Input
                                marginBottom='0px'
                                name="razao_social"
                                type="text"
                                id="razaosocial"
                                label="Razão social do emissor"
                                onChange={e => changeRazaoSocial(e)}
                                erro={erroRazaoSocial}
                                value={razaoSocial}
                            />
                            <Input
                                marginBottom='0px'
                                name="cpf_cnpj"
                                type="cpfcnpj"
                                id="cpfcnpjemissor"
                                label="CPF/CNPJ"
                                onChange={e => changeCpfCnpj(e)}
                                erro={erroCpfCnpj}
                                messageErro={erroCpfCnpjMsg}
                                value={cpfCnpj}
                            />
                            <Input
                                marginBottom='0px'
                                name="endereco"
                                type="text"
                                id="enderecoemissor"
                                label="Endereço"
                                onChange={e => changeEndereco(e)}
                                erro={erroEndereco}
                                value={endereco}
                            />
                            <Input
                                marginBottom='0px'
                                name="bairro"
                                type="text"
                                id="bairroemissor"
                                label="Bairro"
                                onChange={e => changeBairro(e)}
                                erro={erroBairro}
                                value={bairro}
                            />
                            <Input
                                marginBottom='0px'
                                name="municipio"
                                type="text"
                                id="municipioemissor"
                                label="Município"
                                onChange={e => changeMunicipio(e)}
                                erro={erroMunicipio}
                                value={municipio}
                            />

                            <SelectV2
                                marginBottom='0px'
                                name="estado"
                                className="select"
                                label="UF emissor"
                                id="estadoemissor"
                                value={estado ? estado.value : estado}
                                onChange={estado => (changeEstado(estado))}
                                options={estados}
                                isClearable={false}
                                selectUniqueOption={false}
                                loading={loading}
                                erro={erroEstado}
                                minHeight="70px"
                            />

                            <Input
                                marginBottom='0px'
                                id="dataemissaonf"
                                onChange={e => changeDataEmissao(e)}
                                label="Data de emissão"
                                mask="99/99/9999"
                                value={dataEmissao}
                                disabled={false}
                                erro={erroDataEmissao}
                                messageErro="Data da NF não pode ser anterior à emissão da receita."
                                type="date"
                            />

                            {produtos && produtos.length > 0 ? (
                                produtos.map((produto, index) => (
                                    <S.ContainerProducts key={`produto-${index}`}>
                                        <div style={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            <div className='input_area'>
                                                <Input
                                                    marginBottom='0px'
                                                    name={`produto-${index}`}
                                                    type="text"
                                                    id={`produto-${index}`}
                                                    label={`Produto`}
                                                    value={newProdutos[index] !== undefined ? newProdutos[index] : (produto.nome_comercial && produto.fabricante ? `${produto.nome_comercial} - ${produto.fabricante}` : produto.nome_comercial || '')}
                                                    onChange={(e) => changeProduto(e, index)}
                                                />
                                            </div>

                                            <div className='input_area'>
                                                <SelectV2
                                                    name="unidade_medida"
                                                    className="select"
                                                    label="Unidade de medida"
                                                    id={`unidademedida${index}`}
                                                    options={unidadeMedida}
                                                    value={produto.unidade ? produto.unidade.value || produto.unidade : ''}
                                                    onChange={(e) => changeUnidade(e, index)}
                                                    selectUniqueOption={true}
                                                    marginBottom='10px'
                                                    erro={erroUnidades}
                                                />
                                            </div>
                                        </div>

                                        <div className='align' style={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            <div className='input_area'>
                                                <Input
                                                    marginBottom='8px'
                                                    name={`qtd-produto-${index}`}
                                                    type="text"
                                                    id={`qtd-produto-${index}`}
                                                    label="Quantidade do produto"
                                                    legenda={`Quantidade de produto adquirida`}
                                                    onChange={(e) => changeQuantidade(e, index)}
                                                    value={produto.quantidade || ''}
                                                    erro={erroQuantidade}
                                                    messageErro="Informe número (inteiro ou decimal)."
                                                />
                                            </div>

                                            <div className='input_area_2'>
                                                <Input
                                                    name={`unidade-${index}`}
                                                    type="text"
                                                    id={`unidade-${index}`}
                                                    label="NCM do Produto"
                                                    legenda={`Nomenc. Comum do Mercosul. Ex: 84193100 (produtos agrícolas)`}
                                                    value={produto.ncm || ''}
                                                    onChange={(e) => changeNcmProduto(e, index)}
                                                    marginBottom='0px'
                                                    erro={erroNcmProduto}
                                                    messageErro="Informe apenas números (sem letras)."
                                                />
                                            </div>
                                        </div>
                                    </S.ContainerProducts>
                                ))
                            ) : (
                                <S.ContainerProducts>
                                    <div style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        <div className='input_area'>
                                            <Input
                                                marginBottom='0px'
                                                name="produto"
                                                type="text"
                                                id="produto"
                                                label="Produto"
                                                onChange={e => changeProduto(e)}
                                                erro={erroProduto}
                                                value={typeof produto === 'string' ? produto : (newProduto !== null && newProduto !== undefined ? newProduto : (produto?.nome_comercial && produto?.fabricante ? `${produto.nome_comercial} - ${produto.fabricante}` : produto?.nome_comercial || ''))}
                                            />

                                        </div>

                                        <div className='input_area'>
                                            <SelectV2
                                                name="unidade_medida"
                                                className="select"
                                                label="Unidade de medida"
                                                id="unidademedida"
                                                options={unidadeMedida}
                                                value={unidade.value || unidade}
                                                onChange={(e) => changeUnidade(e)}
                                                selectUniqueOption={true}
                                                marginBottom='10px'
                                                erro={erroUnidades}
                                            />
                                        </div>
                                    </div>

                                    <div className='align' style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>

                                        <div className='input_area'>
                                            <Input
                                                marginBottom='8px'
                                                name="qtd_produto"
                                                type="text"
                                                id="qtd_produto"
                                                label="Quantidade do produto"
                                                onChange={e => changeQuantidade(e)}
                                                legenda={`Quantidade de produto adquirida`}
                                                erro={erroQuantidade}
                                                value={quantidade}
                                                messageErro="Informe número (inteiro ou decimal)."
                                            />
                                        </div>

                                        <div className='input_area_2'>
                                            <Input
                                                name="ncm_produtos"
                                                type="text"
                                                id="ncm_produtos"
                                                label="NCM do produto"
                                                legenda={`Nomenc. Comum do Mercosul. Ex: 84193100 (produtos agrícolas)`}
                                                onChange={e => changeNcmProduto(e)}
                                                value={ncmProduto}
                                                erro={erroNcmProduto}
                                                marginBottom='0px'
                                                messageErro="Informe apenas números (sem letras)."
                                                min={1}
                                            />
                                        </div>
                                    </div>
                                </S.ContainerProducts>
                            )}

                            <S.ButtonPlans>
                                <ButtonV2
                                    width='80%'
                                    height='60px'
                                    value='Enviar Nota Fiscal'
                                    outline={false}
                                    disabled={!formValido}
                                    onClick={enviarNotaFiscal}
                                    loading={loadingSendNF}
                                />
                            </S.ButtonPlans>
                        </S.ContainerNF>
                    </S.ContainerNFInfo>


                </S.ContainerModal>
            </ModalGeneric>

            <ModalGeneric
                show={showModalNFMG && !loadingNFMG}
                onHide={() => {
                    setShowModalNFMG(false);
                    setTentouEnviarNFMG(false);
                    setErroSerieNf(false);
                    setErroNumNf(false);
                    setErroDataEmissao(false);
                    setErroQuantidade(false);
                    setNewProduto(null);
                    setNewProdutos([]);
                }}
                marginBottom='0'
            >
                <S.ContainerModalNfMG>
                    <H5>Dados da Nota Fiscal</H5>

                    <S.ContainerNFInfo>
                        <S.ContainerNF>
                            <Input
                                type="text"
                                marginBottom="0"
                                name="serie_nf"
                                id="serie"
                                label="Série da nota"
                                help={true}
                                helpClick={() => setShowModalSerie(true)}
                                onChange={(e) => changeSerieNf(e)}
                                value={serieNf}
                                erro={tentouEnviarNFMG && erroSerieNf}
                            />
                            <Input
                                type="text"
                                marginBottom="0"
                                name="num_nf"
                                id="num_nf"
                                label="Número da nota"
                                onChange={(e) => changeNumNf(e)}
                                value={numNf}
                                erro={tentouEnviarNFMG && erroNumNf}
                            />
                            <Input
                                id="dataemissaonf"
                                marginBottom="0"
                                onChange={(e) => changeDataEmissao(e)}
                                label="Data de emissão"
                                mask="9999-99-99"
                                value={dataEmissao}
                                disabled={false}
                                erro={tentouEnviarNFMG && erroDataEmissao}
                                type="date"
                            />

                            <div style={{ width: '100%', marginTop: '10px' }}>
                                <Relation
                                    relations={relationsSicca}
                                    produtos={produtosSelecionadosSicca}
                                    quantidades={quantidadesSicca}
                                    embalagens={embalagensSicca}
                                    updateProduto={(e) => setProdutosSelecionadosSicca(Array.isArray(e) ? [...e] : e)}
                                    updateEmbalagemValue={(e) => setEmbalagensSicca(Array.isArray(e) ? [...e] : e)}
                                    updateQuantidade={(e) => setQuantidadesSicca(Array.isArray(e) ? [...e] : e)}
                                />
                            </div>

                            <S.ButtonPlans>
                                <ButtonV2
                                    width='80%'
                                    height='60px'
                                    value='Enviar Nota Fiscal'
                                    outline={false}
                                    disabled={!formValido}
                                    onClick={enviarNotaFiscal}
                                    loading={loadingSendNF}
                                />
                            </S.ButtonPlans>
                        </S.ContainerNF>
                    </S.ContainerNFInfo>


                </S.ContainerModalNfMG>
            </ModalGeneric>

            <ModalGeneric
                show={showModalNFBA}
                onHide={() => {
                    setShowModalNFBA(false);
                    setNumNFBA('');
                    setErroNumNFBA(false);
                }}
                marginBottom='0'
            >
                <S.ContainerModal>
                    <H5>Dados da Nota Fiscal</H5>
                    <S.ContainerNFInfo>
                        <S.ContainerNF>
                            <Input
                                marginBottom='0px'
                                name="num_nf_ba"
                                type="text"
                                id="num_nf_ba"
                                label="Número da nota"
                                onChange={e => {
                                    const raw = e && e.target ? e.target.value : e;
                                    const v = String(raw).replace(/\D+/g, '');
                                    setNumNFBA(v);
                                    setErroNumNFBA(!v || String(v).trim() === '');
                                }}
                                onBlur={() => {
                                    const v = String(numNFBA || '').trim();
                                    const onlyDigits = /^\d+$/.test(v);
                                    setErroNumNFBA(!v || !onlyDigits);
                                }}
                                messageErro="Informe somente números."
                                erro={erroNumNFBA}
                                value={numNFBA}
                            />
                            <S.ButtonPlans>
                                <ButtonV2
                                    width='80%'
                                    height='60px'
                                    value='Enviar Nota Fiscal'
                                    outline={false}
                                    disabled={!numNFBA || String(numNFBA).trim() === ''}
                                    onClick={enviarNotaFiscal}
                                    loading={loadingSendNF}
                                />
                            </S.ButtonPlans>
                        </S.ContainerNF>
                    </S.ContainerNFInfo>
                </S.ContainerModal>
            </ModalGeneric>

            <ModalGeneric
                size='md'
                show={showModalSerie}
                onHide={() => setShowModalSerie(false)}
            >
                <p>Para o lançamento de cupons fiscais, informar nesse campo as letras <b>CF</b>. Se o documento fiscal não possuir série, informar os números <b>00</b>.</p>
            </ModalGeneric>
        </>
    )
}

export default HomologButtonHistory;
